export enum UserType {
    LiftOperator = 'liftoperator',
    LiftOperatorUser = 'liftoperator_user',
    Supporter = 'supporter',
}

export enum Permission {
    BILLING_NAV = 'BILLING_NAV',
    CUSTOMER_NAV = 'CUSTOMER_NAV',
    CUSTOMER_DETAIL_NAV = 'CUSTOMER_DETAIL_NAV',
    DATA_MANAGEMENT_NAV = 'DATA_MANAGEMENT_NAV',
    EXTERNAL_CODES_NAV = 'EXTERNAL_CODES_NAV',
    FAQ_NAV = 'FAQ_NAV',
    HOSPITALITY_NAV = 'HOSPITALITY_NAV',
    IDENTIFICATIONS_NAV = 'IDENTIFICATIONS_NAV',
    LIFTOPERATOR_CONFIGURATION_NAV = 'LIFTOPERATOR_CONFIGURATION_NAV',
    MAIL_CONFIGURATION_NAV = 'MAIL_CONFIGURATION_NAV',
    STATISTIC_NAV = 'STATISTIC_NAV',
    TEXT_REPLACEMENT_NAV = 'TEXT_REPLACEMENT_NAV',
    TICKETS_NAV = 'TICKETS_NAV',
    WEBSHOP_NAV = 'WEBSHOP_NAV',
    TICKETS_CANCEL = 'TICKETS_CANCEL',

    B2B = 'B2B_NAV',
    ADMIN = 'ADMIN',
    SUPPORTER = 'SUPPORTER',
    LIFTOPERATOR = 'LIFTOPERATOR',
}

export type User = {
    id?: string;
    liftOperatorId: string;
    password: string;
    username: string;
    permissions: Permission[];
};

export type CreateUser = Omit<User, 'id'>;

export const createPlainCreateUser = (liftOperatorId: string) => ({
    liftOperatorId: liftOperatorId,
    username: '',
    password: '',
    permissions: [],
});

export const permissionTranslation: Record<Permission, string> = {
    BILLING_NAV: 'Abrechnung',
    CUSTOMER_NAV: 'Kunden',
    CUSTOMER_DETAIL_NAV: 'Kunden-Detailansicht',
    DATA_MANAGEMENT_NAV: 'Datenverwaltung',
    EXTERNAL_CODES_NAV: 'External Codes',
    FAQ_NAV: 'FAQs',
    HOSPITALITY_NAV: 'Hospitality',
    IDENTIFICATIONS_NAV: 'Spezialtarife',
    LIFTOPERATOR_CONFIGURATION_NAV: 'Produktkonfiguration',
    MAIL_CONFIGURATION_NAV: 'Mailkonfiguration',
    STATISTIC_NAV: 'Statistik',
    TEXT_REPLACEMENT_NAV: 'Textanpassungen',
    TICKETS_NAV: 'Tickets',
    WEBSHOP_NAV: 'Webshops',
    ADMIN: 'Admin',
    TICKETS_CANCEL: 'Tickets stornieren',
    B2B_NAV: 'B2B-Verwaltung',
    SUPPORTER: 'Supporter',
    LIFTOPERATOR: 'LiftOperator',
};

export const isOfTypeUser = (user: User | CreateUser): user is User =>
    !!user?.['id'];
